module.exports = __webpack_public_path__ + "static/media/class_job_008.56cfabc9.svg";